import { Form, Tab } from '@mairistem/composants';
import type { LigneEngagement, LigneFacture } from '@mairistem/comptabilite';
import React from 'react';

interface LigneMouvementLiaisonProps {
	ligneEngagement: LigneEngagement;
	ligneFacture: LigneFacture;
}

const getValue = (numeroPiece: string, idLigne: number) =>
	[
		...(numeroPiece ? [numeroPiece] : []),
		...(idLigne ? [`(ligne ${idLigne})`] : []),
	].join(' ');

const LigneMouvementLiaison = ({
	ligneEngagement,
	ligneFacture,
}: LigneMouvementLiaisonProps) => (
	<Tab.Pane as={Form}>
		<Form.Group>
			<Form.Input
				data-testid="numeroBonDeCommande"
				label="Bon de commande"
				value={getValue(
					ligneEngagement?.ligneBonDeCommande?.bonDeCommande?.numero,
					ligneEngagement?.ligneBonDeCommande?.numero,
				)}
			/>
			<Form.Input
				data-testid="numeroEngagement"
				label="Engagement"
				value={getValue(
					ligneEngagement?.engagement?.numero,
					ligneEngagement?.idLigne,
				)}
			/>
			<Form.Input
				data-testid="numeroFacture"
				label="Facture"
				value={getValue(ligneFacture?.facture?.numero, ligneFacture?.idLigne)}
			/>
		</Form.Group>
	</Tab.Pane>
);

export default LigneMouvementLiaison;
